import { ThemeInterface } from "../../../../styles/theme";
export const styles = (theme: ThemeInterface) => ({
	checkboxContainer: {
		margin: "3px 0px 3px 15px",
	},
});
export default styles;
